import { useTranslation } from 'next-i18next';
import { FC } from 'react';

import { PlantListItem } from '@/components/PlantListItem';
import { Button } from '@/components/shared/Button';
import { useToggle } from '@/hooks/useToggle';
import { COMMON_LOCALE_PART } from '@/locale';
import { Colors, IPlantDetails } from '@/types';

interface ArboterumPlantsSection {
  plants: Partial<IPlantDetails>[];
}

const ArboterumPlants: FC<ArboterumPlantsSection> = ({ plants }) => {
  const { t } = useTranslation(COMMON_LOCALE_PART);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [showMorePlants, _, setMorePlants] = useToggle();

  const firstSix = showMorePlants ? plants : plants.slice(0, 6);

  const handleShowMorePlants = () => setMorePlants(true);

  return (
    <div className="mt-24">
      <div className="mb-7 text-left">
        <h2 className="max-w-[190px] leading-6 md:max-w-full">{t('content-page.plantsList.title')}</h2>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        {firstSix.map((plant) => (
          <PlantListItem key={plant.id} plant={plant as IPlantDetails} />
        ))}
      </div>

      <div className="m-auto mb-12 mt-7 flex w-full justify-center">
        {plants.length > 6 && !showMorePlants && (
          <Button variant={Colors.primary} onClick={handleShowMorePlants}>
            {t('content-page.plantsList.more')}
          </Button>
        )}
      </div>
    </div>
  );
};

export default ArboterumPlants;
